import React from "react";
import { DialogTitle } from "@headlessui/react";
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useDialog } from "../../contexts/DialogContext";

export function TwoButtonModal({
  titleText,
  bodyText,
  variant = "success",
  actionText,
  cancelText,
  onCancel,
  onAction,
}) {
  const { closeDialog } = useDialog();

  return (
    <>
      <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
        <button
          type="button"
          onClick={closeDialog}
          className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          <span className="sr-only">Close</span>
          <XMarkIcon aria-hidden="true" className="h-6 w-6" />
        </button>
      </div>

      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          {variant === "success" ? (
            <CheckCircleIcon
              aria-hidden="true"
              className="h-6 w-6 text-green-600"
            />
          ) : (
            <ExclamationTriangleIcon
              aria-hidden="true"
              className="h-6 w-6 text-red-600"
            />
          )}
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <DialogTitle
            as="h3"
            className="text-base font-semibold leading-6 text-gray-900"
          >
            {titleText}
          </DialogTitle>
          <div className="mt-2">
            <p className="text-sm text-gray-500">{bodyText}</p>
          </div>
        </div>
      </div>

      <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          onClick={() => {
            onAction();
            closeDialog();
          }}
          className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
        >
          {actionText}
        </button>
        <button
          type="button"
          onClick={() => {
            onCancel();
            closeDialog();
          }}
          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
        >
          {cancelText}
        </button>
      </div>
    </>
  );
}
